import reducer, { actions, selectors, STATE_KEY } from './modules/slice';
import saga from './modules/saga';

export { reducer, actions, selectors, saga };
export const customersStateKey = STATE_KEY;
